const SIDEBAR_WIDTH = 210;

export { SIDEBAR_WIDTH };
